var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "payments"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2137_2124",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2137_2124)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "payments_2",
    d: "M14 13.5C13.1667 13.5 12.4583 13.2083 11.875 12.625C11.2917 12.0417 11 11.3333 11 10.5C11 9.66667 11.2917 8.95833 11.875 8.375C12.4583 7.79167 13.1667 7.5 14 7.5C14.8333 7.5 15.5417 7.79167 16.125 8.375C16.7083 8.95833 17 9.66667 17 10.5C17 11.3333 16.7083 12.0417 16.125 12.625C15.5417 13.2083 14.8333 13.5 14 13.5ZM7 16.5C6.45 16.5 5.97917 16.3042 5.5875 15.9125C5.19583 15.5208 5 15.05 5 14.5V6.5C5 5.95 5.19583 5.47917 5.5875 5.0875C5.97917 4.69583 6.45 4.5 7 4.5H21C21.55 4.5 22.0208 4.69583 22.4125 5.0875C22.8042 5.47917 23 5.95 23 6.5V14.5C23 15.05 22.8042 15.5208 22.4125 15.9125C22.0208 16.3042 21.55 16.5 21 16.5H7ZM9 14.5H19C19 13.95 19.1958 13.4792 19.5875 13.0875C19.9792 12.6958 20.45 12.5 21 12.5V8.5C20.45 8.5 19.9792 8.30417 19.5875 7.9125C19.1958 7.52083 19 7.05 19 6.5H9C9 7.05 8.80417 7.52083 8.4125 7.9125C8.02083 8.30417 7.55 8.5 7 8.5V12.5C7.55 12.5 8.02083 12.6958 8.4125 13.0875C8.80417 13.4792 9 13.95 9 14.5ZM20 20.5H3C2.45 20.5 1.97917 20.3042 1.5875 19.9125C1.19583 19.5208 1 19.05 1 18.5V7.5H3V18.5H20V20.5Z",
    fill: "#4D2481"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.dc16d1816047be35613d413653f4a81b.svg";
export { ForwardRef as ReactComponent };